import { render, staticRenderFns } from "./taskDetailsInfo.vue?vue&type=template&id=7d30ec1a&scoped=true&"
import script from "./taskDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./taskDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./taskDetailsInfo.vue?vue&type=style&index=0&id=7d30ec1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d30ec1a",
  null
  
)

export default component.exports